import { Link } from "react-router-dom";
import TopicOne from "../../resource-contents/economic-calendar-contents/TopicOne";

const EconomicCalendarContentOne = () => {
  return (
    <>
      <TopicOne />
      <div className="how__work__resource">
        <div className="container">
          <div className="row">
            <div className="col-lg-6 col-md-12 col-sm-12 col-12">
              <div className="content-left">
                <h2>Your Market Compass</h2>
                <p>
                  The Pips Economic Calendar provides up-to-date information on
                  global economic releases, central bank decisions, and
                  geopolitical developments. It helps traders anticipate
                  volatility, understand market drivers, and align trades with
                  key financial events, all in one easy-to-navigate view. With
                  customizable filters, you can track events by country, impact
                  level, or market category to match your trading strategy.
                  Real-time updates ensure you never miss a critical
                  announcement that could influence price movements. Designed
                  for both new and experienced traders, the calendar simplifies
                  complex economic data into actionable insights.
                </p>
                <Link
                  className="slide__btn dg__btn"
                  to={process.env.PUBLIC_URL + "/company/contact"}
                >
                  Explore Now
                </Link>
              </div>
            </div>
            <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
              <div className="thumb-right">
                <img
                  src={
                    process.env.PUBLIC_URL +
                    "/images/resources/economic_calendar/economic_calendar_1.png"
                  }
                  alt="computer images"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default EconomicCalendarContentOne;
